import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from "react";
import api from "@/lib/api";
import { translations } from "@/i18n";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("db_lang") || "te");
  const [settings, setSettings] = useState(null);
  const [soundOn, setSoundOn] = useState(() => localStorage.getItem("db_sound") !== "off");
  const [notifData, setNotifData] = useState({ items: [], unread: 0 });
  const audioCtxRef = useRef(null);

  const t = useCallback((key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key, [lang]);

  const toggleLang = () => setLang((l) => { const n = l === "te" ? "en" : "te"; localStorage.setItem("db_lang", n); return n; });
  const toggleSound = () => setSoundOn((s) => { localStorage.setItem("db_sound", !s ? "on" : "off"); return !s; });

  const playBell = useCallback(() => {
    if (!soundOn) return;
    try {
      if (!audioCtxRef.current) audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
      const ctx = audioCtxRef.current;
      const now = ctx.currentTime;
      [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
        const o = ctx.createOscillator(); const g = ctx.createGain();
        o.type = "sine"; o.frequency.value = f;
        g.gain.setValueAtTime(0.0001, now);
        g.gain.exponentialRampToValueAtTime(0.18 / (i + 1), now + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, now + 1.8);
        o.connect(g); g.connect(ctx.destination); o.start(now); o.stop(now + 1.9);
      });
    } catch (e) {}
  }, [soundOn]);

  const loadSettings = useCallback(async () => {
    try { const { data } = await api.get("/settings"); setSettings(data); } catch (e) {}
  }, []);

  const refreshNotifications = useCallback(async () => {
    try { const { data } = await api.get("/notifications"); setNotifData(data); } catch (e) { setNotifData({ items: [], unread: 0 }); }
  }, []);

  useEffect(() => { loadSettings(); }, [loadSettings]);

  return (
    <AppContext.Provider value={{ lang, setLang, toggleLang, t, settings, refreshSettings: loadSettings,
      soundOn, toggleSound, playBell, notifData, refreshNotifications }}>
      {children}
    </AppContext.Provider>
  );
}
